import React from "react";
import failed from "../imgs/failed.svg";
import initiated from "../imgs/initiated.svg";
import successful from "../imgs/successful.svg";

function Table({ data }) {
  return (
    <div className="h-[45px] border-b-[0.5px] border-[#D7E1F4]">
      <div className="flex gap-[10px] text-[#6882B6] justify-start  text-[12px]  leading-none tracking-[2%] ">
        <div className=" min-w-[157px] ">
          <div className="flex items-center gap-2">
            <div className="">
              {data.status === "initiated" ? (
                <img src={initiated} alt="" />
              ) : data.status === "successful" ? (
                <img src={successful} alt="" />
              ) : (
                <img src={failed} alt="" />
              )}
            </div>

            <div className="flex  justify-start flex-col gap-1 text-[#4C689E] text-[12px] leading-none tracking-[2%]">
              <p className="font-semibold ">{data.service}</p>
              <p className=" font-normal">{data.phoneNo}</p>
            </div>
          </div>
        </div>

        <div className="min-w-[90px]">
          <p className="font-semibold">{data.amount}</p>
        </div>

        <div className="min-w-[102px]">
          <p className="font-semibold">₦100.00</p>
        </div>
        <div className="min-w-[85px]">
          {data.status === "initiated" ? (
            <p className="font-semibold text-[#FFB547]">Initiated</p>
          ) : data.status === "successful" ? (
            <p className="font-semibold text-[#2DAE32]">Successful</p>
          ) : (
            <p className="font-semibold text-[#EE5D50]">Failed</p>
          )}
        </div>
        <div className="min-w-[129px]">
          <p className="font-semibold">{data.payment}</p>
        </div>
        <div className="min-w-[233px]">
          <div className="flex  justify-start flex-col gap-1 text-[#4C689E] text-[12px] leading-none tracking-[2%]">
            <p className="font-semibold ">17045621860850336938179613</p>
            <p className=" font-normal">6th January, 2024, 06:29PM</p>
          </div>
        </div>
        <div className="min-w-[53px]">
          <div className="bg-[#EFF3FB] px-2 h-[28px] rounded-md flex items-center justify-center">
            <p className="text-[#4169E1] text-[16px] font-semibold">Open</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Table;
